
var openClass = 'is-open';


//
// Cart Drawer
//
// Synchronise display of overlay and cart steps with expanding of the
// cart summary table.
//

module.exports = function CartDrawer ($host, config) {

  // Dom & Widgets
  var $overlay = $('.cart-drawer-overlay', $host);
  var $steps   = $('.cart-steps', $host);
  var expander = getWidgetAtDom($('[data-widget="expander"]', $host));

  // Functions
  function matchExapnder (opened) {
    $host.toggleClass(openClass, opened);
    $steps.toggle(opened);
  }

  // Listeners
  expander.onChange(matchExapnder);
  $overlay.on('click', expander.toggle);
  document.addEventListener('keydown', whichKey(27, expander.close));

  // Init
  expander.open();

}

